import { render } from "./slide1.vue?vue&type=template&id=16b6af7a&scoped=true"
import script from "./slide1.vue?vue&type=script&lang=js"
export * from "./slide1.vue?vue&type=script&lang=js"

import "./slide1.vue?vue&type=style&index=0&id=16b6af7a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b6af7a"]])

export default __exports__